import { PageAPI } from 'lib/api';
import { apiEnvSelector } from 'common/selectors/appSelector';
import { collectionParamsSelector } from 'common/selectors/apiParamsSelector';

export const START_GET_NETWORKS = 'START_GET_NETWORKS';
export const COMPLETE_GET_NETWORKS = 'COMPLETE_GET_NETWORKS';

export function startGetNetworks() {
    return {
        type: START_GET_NETWORKS,
        startTime: Date.now()
    };
}

export function completeGetNetworks(networks) {
    return {
        type: COMPLETE_GET_NETWORKS,
        completeTime: Date.now(),
        networks
    };
}

export function fetchNetworks() {
    return (dispatch, getState) => {
        const state = getState();
        const apiEnv = apiEnvSelector(state);
        const params = collectionParamsSelector(state);
        dispatch(startGetNetworks());
        return PageAPI.getNetworks(apiEnv, params).then((networks) => {
            dispatch(completeGetNetworks(networks || []));
            return networks;
        });
    };
}



// WEBPACK FOOTER //
// ./app/common/actions/clientActions.js